import * as UnitHelper from './unit.helper';

const uriProduction = 'https://api.sabin.com.br'
const uriDeveloper = 'https://apidev.cloudsabin.com'
const uriStaging   = 'https://api-staging.cloudsabin.com'
const uriLocalhost = 'http://localhost:3000'

const urls = [
  {'localhost:8080': uriLocalhost},
  {'localhost:4200': uriDeveloper},
  {'backofficedev.cloudsabin.com': uriDeveloper},
  {'backoffice-staging.cloudsabin.com': uriStaging},
  {'backoffice.sabin.com.br': uriProduction}
]


const UnitDetailService = function (Restangular) {
  const Service = Restangular.allUrl('admin/attendance_hour', urls.find(elem => elem[window.location.host])[window.location.host]);
  const ServiceAdmin = Restangular.all('admin/attendance_hour_approval');
  const ServiceAdminSpecialHours = Restangular.all('admin/special_hours');
  const ServiceAdminAttendanceHour = Restangular.all('admin/attendance_hour');

  const getAttendanceHour = unitId => Service.customGET('attendance_hour', {unit_id: unitId});

  const getLocationsGMB = () => Service.customPOST({
    "access_token": UnitHelper.getToken()
  }, `units/sync`);

  const syncHoursGMB = unitId => ServiceAdminAttendanceHour.customPUT({
    "access_token": UnitHelper.getToken()
  }, `unit/${unitId}/sync_hours`)

  const requestChangeSchedule = schedules => ServiceAdmin.post(schedules);

  const getRequestChangeSchedule = () => ServiceAdmin.customGET();

  const requestNewSpecialHours = specialHours => ServiceAdminSpecialHours.post(specialHours);

  const rejectSpecialHours = payload => ServiceAdminSpecialHours.customPUT(payload.data, `${payload.id}/reject`)

  const removeSpecialHours = payload => ServiceAdminSpecialHours.customPUT({
    "access_token": UnitHelper.getToken(),
    "hour_id": payload.data.hour_id
  }, `${payload.id}/remove`)

  const approveSpecialHours = unitId => ServiceAdminSpecialHours.customPUT({
    "access_token": UnitHelper.getToken()
  }, `${unitId}/approve`)

  const syncSpecialHours = unitId => ServiceAdminSpecialHours.customPUT({
    "access_token": UnitHelper.getToken()
  }, `${unitId}/sync_hours`)

  return {
    syncHoursGMB,
    getAttendanceHour,
    requestChangeSchedule,
    requestNewSpecialHours,
    getRequestChangeSchedule,
    getLocationsGMB,
    rejectSpecialHours,
    approveSpecialHours,
    removeSpecialHours,
    syncSpecialHours
  };
};

UnitDetailService.$inject = ['Restangular'];

export default UnitDetailService;



// WEBPACK FOOTER //
// ./client/app/components/unit/unit-detail.service.js